/* Neu Appliance Outlet — recommendation rails from the live in-stock index (tasks 86e2f3phv, 86e2f3u94).
   Shopify's native /recommendations/products returns sold-out / off-category / thin results for this
   catalog. Instead we build "Similar Appliances" (PDP) and "You may also like" (cart) from
   filter-index.json, which contains ONLY in-stock, published, categorized products with connectors,
   services and warranties already excluded. Same-category matching, in stock only.

   Hooks (any element):
     data-neu-recs="pdp"   + data-neu-recs-cat="WDSET"  data-neu-recs-exclude="<productId>"
     data-neu-recs="cart"  (categories + exclusions read live from /cart.js; also excludes New in Box)
     data-neu-recs-index="<filter-index.json url>"   data-neu-recs-limit="8" */
(function () {
  if (window.__neuRecs) return;
  window.__neuRecs = true;

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var BADGE_C = { scratch: { bc: 'var(--c-scratch)', bt: '#fff' }, open: { bc: 'var(--c-open)', bt: 'var(--navy)' }, refurb: { bc: 'var(--orange)', bt: '#fff' }, new: { bc: 'var(--c-newbox)', bt: '#fff' } };
  function catOf(e) { return (e.f && e.f.category && e.f.category[0]) ? String(e.f.category[0]).toUpperCase() : ''; }

  function card(p) {
    var b = BADGE_C[p.cond] || BADGE_C.scratch;
    var save = p.cap && p.cap > p.price ? ('You save ' + money(p.cap - p.price) + ' (' + Math.round((p.cap - p.price) / p.cap * 100) + '% off)') : '';
    return '<article class="pcard" data-cond="' + esc(p.cond) + '"><div class="pcard__media pcard__media--photo">' +
      (p.badge ? '<span class="pcard__badge" style="--bc:' + b.bc + ';--bt:' + b.bt + '">' + esc(p.badge) + '</span>' : '') +
      '<a class="pcard__imglink" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' + (p.img2 ? '<img class="pcard__img-alt" src="' + esc(p.img2) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
      '</div><div class="pcard__body"><span class="pcard__brand">' + esc(p.vendor) + '</span>' +
      '<h3 class="pcard__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      '<div class="pcard__rating"><span class="stars" data-stars="5"></span><span>' + (p.liq ? '30-day returns' : 'Neu Shield 1-yr') + '</span></div>' +
      '<div class="pcard__price"><b>' + money(p.price) + '</b>' + (p.cap && p.cap > p.price ? '<s>' + money(p.cap) + '</s>' : '') + '</div>' +
      (save ? '<span class="pcard__save">' + save + '</span>' : '') +
      '<div class="pcard__actions"><a class="btn btn--navy pcard__shop" href="' + esc(p.url) + '">Shop Now</a></div></div></article>';
  }

  function hide(box) { var s = box.closest('section'); if (s) s.style.display = 'none'; else box.style.display = 'none'; }

  function render(box, index, opt) {
    var limit = parseInt(box.getAttribute('data-neu-recs-limit'), 10) || 8;
    var hasCats = Object.keys(opt.wantCats).length > 0;
    if (!hasCats) { hide(box); return; } // no category context -> don't show random products
    var picks = index.filter(function (e) {
      if (opt.excludeIds[String(e.id)]) return false;
      if (opt.excludeNew && e.cond === 'new') return false;
      return !!opt.wantCats[catOf(e)];
    });
    picks.sort(function (a, b) { return (b.added || 0) - (a.added || 0); }); // freshest first
    picks = picks.slice(0, limit);
    if (!picks.length) { hide(box); return; }
    box.innerHTML = picks.map(card).join('');
    if (window.neuFillStars) window.neuFillStars(box);
  }

  function run() {
    var boxes = document.querySelectorAll('[data-neu-recs]');
    if (!boxes.length) return;
    var indexUrl = boxes[0].getAttribute('data-neu-recs-index');
    if (!indexUrl) return;
    fetch(indexUrl).then(function (r) { return r.json(); }).then(function (index) {
      var byId = {};
      index.forEach(function (e) { byId[String(e.id)] = e; });
      boxes.forEach(function (box) {
        var mode = box.getAttribute('data-neu-recs');
        if (mode === 'cart') {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var cats = {}, ids = {};
            (cart.items || []).forEach(function (it) {
              var pid = String(it.product_id); ids[pid] = 1;
              var e = byId[pid]; if (e) { var c = catOf(e); if (c) cats[c] = 1; }
            });
            render(box, index, { wantCats: cats, excludeIds: ids, excludeNew: true });
          }).catch(function () { hide(box); });
        } else {
          var wantCats = {};
          (box.getAttribute('data-neu-recs-cat') || '').split(',').forEach(function (c) { c = c.trim().toUpperCase(); if (c) wantCats[c] = 1; });
          var ids = {};
          (box.getAttribute('data-neu-recs-exclude') || '').split(',').forEach(function (id) { id = id.trim(); if (id) ids[id] = 1; });
          render(box, index, { wantCats: wantCats, excludeIds: ids, excludeNew: false });
        }
      });
    }).catch(function () { boxes.forEach(hide); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
